/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EarningsSummary } from './EarningsSummary';
import {
    EarningsSummaryFromJSON,
    EarningsSummaryFromJSONTyped,
    EarningsSummaryToJSON,
    EarningsSummaryToJSONTyped,
} from './EarningsSummary';
import type { RawRateSummary } from './RawRateSummary';
import {
    RawRateSummaryFromJSON,
    RawRateSummaryFromJSONTyped,
    RawRateSummaryToJSON,
    RawRateSummaryToJSONTyped,
} from './RawRateSummary';

/**
 * A response to a rate validation request with raw rate summary
 * @export
 * @interface RateValidationRawRateSummary
 */
export interface RateValidationRawRateSummary {
    /**
     * 
     * @type {RawRateSummary}
     * @memberof RateValidationRawRateSummary
     */
    rawRateSummary?: RawRateSummary;
    /**
     * 
     * @type {EarningsSummary}
     * @memberof RateValidationRawRateSummary
     */
    earningsSummary?: EarningsSummary;
}

/**
 * Check if a given object implements the RateValidationRawRateSummary interface.
 */
export function instanceOfRateValidationRawRateSummary(value: object): value is RateValidationRawRateSummary {
    return true;
}

export function RateValidationRawRateSummaryFromJSON(json: any): RateValidationRawRateSummary {
    return RateValidationRawRateSummaryFromJSONTyped(json, false);
}

export function RateValidationRawRateSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): RateValidationRawRateSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'rawRateSummary': json['raw_rate_summary'] == null ? undefined : RawRateSummaryFromJSON(json['raw_rate_summary']),
        'earningsSummary': json['earnings_summary'] == null ? undefined : EarningsSummaryFromJSON(json['earnings_summary']),
    };
}

export function RateValidationRawRateSummaryToJSON(json: any): RateValidationRawRateSummary {
    return RateValidationRawRateSummaryToJSONTyped(json, false);
}

export function RateValidationRawRateSummaryToJSONTyped(value?: RateValidationRawRateSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'raw_rate_summary': RawRateSummaryToJSON(value['rawRateSummary']),
        'earnings_summary': EarningsSummaryToJSON(value['earningsSummary']),
    };
}

